export default function Footer() {
  const quickLinks = [
    { label: '最新爆料', href: '#updates' },
    { label: '热议榜单', href: '#ranking' },
    { label: '深度扒皮', href: '#cards' },
    { label: '专题合集', href: '#index' },
    { label: '视频吃瓜', href: '#media' },
    { label: '投稿爆料', href: '#contact' },
  ];

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          {/* Top row */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
            {/* Brand */}
            <div>
              <span className="text-2xl font-heading font-bold text-background-50">
                黑料
              </span>
              <span className="ml-2 text-xs bg-accent-500 text-background-950 px-2 py-0.5 rounded-full font-semibold">
                吃瓜网
              </span>
              <p className="mt-4 text-sm leading-relaxed text-background-400">
                黑料吃瓜网专注爆料与八卦，实时追踪网红黑料、热点事件和娱乐圈最新动态。为吃瓜群众提供第一手黑料吃瓜视频和深度扒皮内容，黑料吃瓜不打烊，随时随地满足你的八卦好奇心。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                快速导航
              </h4>
              <div className="grid grid-cols-2 gap-2">
                {quickLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            {/* Partners */}
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                合作伙伴
              </h4>
              <p className="text-sm text-background-500 leading-relaxed">
                感谢所有合作伙伴的支持与信任，携手打造更精彩的吃瓜体验。
              </p>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 黑料吃瓜网. 本站内容仅供娱乐参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <span>黑料吃瓜在线</span>
              <span className="text-background-700">|</span>
              <span>吃瓜黑料合集</span>
              <span className="text-background-700">|</span>
              <span>黑料吃瓜不打烊</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}